import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import socketService from '../services/socket';

const WorkspaceContext = createContext(null);

export const useWorkspace = () => {
    const context = useContext(WorkspaceContext);
    if (!context) {
        throw new Error('useWorkspace must be used within WorkspaceProvider');
    }
    return context;
};

export const WorkspaceProvider = ({ children }) => {
    const { workspaces } = useAuth();
    const [currentWorkspace, setCurrentWorkspace] = useState(null);

    useEffect(() => {
        // Set first workspace as default
        if (workspaces && workspaces.length > 0 && !currentWorkspace) {
            const savedWorkspaceId = localStorage.getItem('currentWorkspaceId');

            // Try to find the saved workspace in the user's available workspaces
            let workspace = savedWorkspaceId
                ? workspaces.find(w => w.id === savedWorkspaceId)
                : null;

            // If saved workspace is not found (invalid ID or user has no access), fallback to first available
            if (!workspace) {
                workspace = workspaces[0];
            }

            if (workspace) {
                switchWorkspace(workspace);
            }
        }
    }, [workspaces]);

    const switchWorkspace = (workspace) => {
        if (currentWorkspace) {
            socketService.leaveWorkspace(currentWorkspace.id);
        }

        setCurrentWorkspace(workspace);
        localStorage.setItem('currentWorkspaceId', workspace.id);
        socketService.joinWorkspace(workspace.id);
    };

    const value = {
        currentWorkspace,
        switchWorkspace,
        workspaces
    };

    return (
        <WorkspaceContext.Provider value={value}>
            {children}
        </WorkspaceContext.Provider>
    );
};
